import { render, staticRenderFns } from "./tableAttrsDlg.vue?vue&type=template&id=64ab84f5&"
import script from "./tableAttrsDlg.vue?vue&type=script&lang=js&"
export * from "./tableAttrsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports